import React from 'react';
import { Link } from 'react-router-dom';
import './TryFreeBtn.css';

const TryFreeBtn = ({ asSubmit = false, disabled = false, text = 'Try How It Works' }) => {
  if (asSubmit) {
    return (
      <div className="try-free-btn-group">
        <button type="submit" className="try-free-btn try-free-btn-primary" disabled={disabled}>
          {disabled ? <><span className="spinner"></span>Sending...</> : text}
        </button>
        <a href="https://wa.me/35796735715" target="_blank" rel="noopener noreferrer" className="try-free-btn try-free-btn-whatsapp">
          Ask in WhatsApp
        </a>
      </div>
    );
  }
  return (
    <div className="try-free-btn-group">
      <Link to="/guide/contact" className="try-free-btn try-free-btn-primary">{text}</Link>
      <a href="https://wa.me/35796735715" target="_blank" rel="noopener noreferrer" className="try-free-btn try-free-btn-whatsapp">
        Ask in WhatsApp
      </a>
    </div>
  );
};

export default TryFreeBtn;

